import { render, staticRenderFns } from "./crossoverActivityManagement.vue?vue&type=template&id=5b3d76fc"
import script from "./crossoverActivityManagement.vue?vue&type=script&lang=js"
export * from "./crossoverActivityManagement.vue?vue&type=script&lang=js"
import style0 from "./crossoverActivityManagement.vue?vue&type=style&index=0&id=5b3d76fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports